// ======================================================================
// File Name       : BatchHistory
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Col, Form, Row } from 'react-bootstrap';
import TableHead, { setSortState } from '../components/TableHead';
import PaginationCustom from '../components/Pagination';
import { CSV_REGISTRATION_STATUS } from '../constants/index';
import { parseDateForDetail, isIE, parseImportHistory } from '../utils/index';
import CustomLink from './button/CustomLink';
import * as ICON from '../constants/IconConstants';

/**
 * Batch History Component
 *
 * @class BatchHistory
 * @extends {React.Component}
 */
function BatchHistory(props) {
  const { dataSort } = props;
  const thead = [
    { title: 'No', sortBy: null, width: 50 },
    { title: 'ファイル名', sortBy: 0 },
    { title: 'ステータス', sortBy: 1, width: 110 },
    { title: '開始日時', sortBy: 2, width: 165 },
    { title: '完了日時', sortBy: 3, width: 165 },
    { title: 'エラー件数', sortBy: 4, width: 115 },
    { title: '処理結果', sortBy: null, width: 120 },
  ];
  let data = thead;
  if (dataSort) {
    const sortBy = dataSort.importSortType;
    const sortState = dataSort.ascendingDescendingSort;
    data = setSortState(thead, sortBy, sortState);
  }
  const startPosition = props.startPosition;
  const isIEBroswer = isIE();
  const histories = props.resultInfo.importResultList.map((history, index) => (
    <tr key={index}>
      <td>{startPosition + index + 1}</td>
      <td>{history.importFileName}</td>
      <td>
        {history.importResultStatus === CSV_REGISTRATION_STATUS.PROCESSED
          ? '処理済'
          : history.importResultStatus === CSV_REGISTRATION_STATUS.PROCESSING ? '処理中' : '処理待ち'}
      </td>
      <td>{parseDateForDetail(history.importStartTime)}</td>
      <td>{parseDateForDetail(history.importEndTime)}</td>
      <td>{parseImportHistory(history.importErrorCount, history.importEndTime)}</td>
      <td className="text-center padding-clear">
        {history.resultFileUrl ? (
          <Button
            variant="outline-primary"
            className="btn-96 btn-edit"
            onClick={props.onClickDownload.bind(
              this,
              history.resultFileUrl,
              history.importFileName,
            )}
            id={index}
          >
            ダウンロード
          </Button>
        ) : null}
      </td>
    </tr>
  ));
  return (
    <div>
      <Row className="margin-top-10 margin-bottom-15">
        <Col>
          一括投入結果一覧
        </Col>
        <Col xs="auto">
          <CustomLink
            className="btn btn-rotate inline-flex"
            icon={ICON.ROTATE}
            text="更新"
            onClick={props.renderData}
          />
        </Col>
      </Row>
      <Table striped hover>
        <thead>
          <TableHead data={data} handleSortState={props.handleSortState} />
        </thead>
        <tbody>{histories}</tbody>
      </Table>
      <Col className="d-flex justify-content-center">
        <PaginationCustom
          startPosition={startPosition}
          recordNum={props.resultInfo.recordNum}
          handlePageSelect={props.handlePageSelect}
        />
      </Col>
    </div>
  );
}

BatchHistory.propTypes = {
  renderData: PropTypes.func.isRequired,
  handleSortState: PropTypes.func.isRequired,
  handlePageSelect: PropTypes.func.isRequired,
  startPosition: PropTypes.number.isRequired,
  resultInfo: PropTypes.shape().isRequired,
};

export default BatchHistory;
